import React from 'react';
import _ from 'lodash';

import DDadosBase from '@common/components/ddados/ddados.base';
import Panel from '@common/components/panel/panel.component';
import Field from '@common/components/validation/field.validation';

import { Row, Col } from 'react-bootstrap';

class BaseComponent extends DDadosBase {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    const { Itens, Label, name, Desabilitado, RemovePanel, isView } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChange, onBlur }) => {
          return (
            <Row>
              <Col lg={12}>
                {!RemovePanel ? (
                  <Panel title={Label}>
                    <div className="form-inline">
                      {Itens.map((item, i) => {
                        return (
                          <Col key={i} className="form-group" lg={item.Tamanho || 3}>
                            <div className="radio">
                              <label title={isView ? '' : item.Tooltip || item.Texto}>
                                <input
                                  type="radio"
                                  name={name}
                                  disabled={Desabilitado}
                                  value={item.Valor}
                                  onChange={onChange}
                                  checked={value == item.Valor}
                                />{' '}
                                {item.Texto}
                              </label>
                            </div>
                          </Col>
                        );
                      })}
                    </div>
                  </Panel>
                ) : (
                  <div className="form-inline">
                    {Itens.map((item, i) => {
                      return (
                        <Col key={i} className="form-group" lg={item.Tamanho || 3}>
                          <div className="radio">
                            <label title={isView ? '' : item.Tooltip || item.Texto}>
                              <input
                                type="radio"
                                style={{ marginRight: "5px" }}
                                name={name}
                                disabled={Desabilitado}
                                value={item.Valor}
                                onChange={onChange}
                                checked={value == item.Valor}
                              />{' '}
                              {item.Texto}
                            </label>
                          </div>
                        </Col>
                      );
                    })}
                  </div>
                )}
              </Col>
            </Row>
          );
        }}
      </Field>
    );
  }
}

export default BaseComponent;
